<template>
	<card class="is-card-table has-pagination has-table-borderless has-bottom-left-hidden" title="企業一覧" icon="format-list-bulleted">
	<!--
		<customer-table-toolbar slot="toolbar" @checkbox-click="onIsHiddenContainCheckboxClick"/>
		-->
		<customer-table :data="data" :totalNum="totalNum" :isLoading="isLoading" :checkable="false"/>
	</card>
</template>

<script>
import Card from "@/components/Card";
import CustomerTable from "@/components/CustomerTable";
import CustomerTableToolbar from "@/components/CustomerTableToolbar";
import qs from 'qs';

export default {
	name: 'customer',
	components: {
		Card,
		CustomerTable,
		CustomerTableToolbar,
	},
	data() {
		return {
			data: [],
			isLoading: false,
			totalNum: 0,
		}
	},
	mounted() {
		this.init();
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['企業管理']
		});
	},
	methods: {
		onNewButtonClick: function() {
			this.$router.push({ name: 'customer-new' });
		},
		onIsHiddenContainCheckboxClick: function(val) {
			this.$utils.log(val);
			this.getData(val);
		},
		init: function() {
			this.getData(0);
		},
		getData: async function(isHiddenContain) {
			this.isLoading = true;
			let data = {
				"is_hidden_contain": isHiddenContain,
			};
			this.$utils.log(data);

			let ep = 'customers?' + qs.stringify(data);
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				if (!res.data) {
					this.data = [];
				} else {
					this.data = res.data;
				}
				this.totalNum = this.data.length;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isLoading = false;
			}
		},
	},
}
</script>

<style scoped>
</style>
